import { useLazyQuery } from '@apollo/client';

import { fetchBasicInfo } from '../queries/fetchBasicInfo';

import { BasicInfoQuery, BasicInfoQueryVariables } from '@typings/operations';

export const useBasicInfo = () =>
  useLazyQuery<BasicInfoQuery, BasicInfoQueryVariables>(fetchBasicInfo);
